<template>
  <b-container>
    <div class="wrap-program">
      <div class="box-page">
        <div class="box-title">
          <h1>{{ symposiumProgramTitle }}</h1>
          <div class="box-button-p10">
            <a v-if="symposiumDownloadProgramBtn" v-show="symposiumDownloadProgramBtn.isDisplay"
              :href="symposiumDownloadProgramBtn.upload_url" target="_blank">
              {{ symposiumDownloadProgramBtn.name }}
            </a>
            <a v-if="buyTicketBtn" v-show="buyTicketBtn.isDisplay" :href="buyTicketBtn.url" target="_blank">
              {{ buyTicketBtn.name }}
            </a>
            <router-link v-if="watchPastBtn" v-show="watchPastBtn.isDisplay" :to="watchPastBtn.url || ''"
              target="_blank">
              {{ watchPastBtn.name }}
            </router-link>
          </div>
        </div>
        <div class="box-content">
          <Skeleton v-if="isLoading" width="100%" height="660px" />
          <img v-if="!isLoading" :src="programs.imageUrl" />
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'
import { getBaseMetaCurrentYear } from '@/environments'

const Skeleton = () => import('@/components/Loading/Skeleton')

export default {
  components: {
    Skeleton
  },

  data () {
    return {
      baseCurrentYear: getBaseMetaCurrentYear,
      programs: {
        pdfUrl: '',
        imageUrl: ''
      }
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      isLoading: state => state.creativity.isLoading,
      programsRaw: state => state.creativity.programs,
      notDateActivate: state => state.symposium.notDateActivate
    }),
    buyTicketBtn () {
      return this.configMap.get('buyTicketBtn')
    },
    watchPastBtn () {
      return this.configMap.get('watchPastBtn')
    },
    symposiumDownloadProgramBtn () {
      return this.configMap.get('symposiumDownloadProgramBtn')
    },
    symposiumProgramTitle () {
      const mConfig = this.configMap.get('symposiumProgramTitle')
      return mConfig ? mConfig.name : 'Adman Awards & Symposium 2025 Program'
    }
  },

  methods: {
    matchImgUrl (urls) {
      urls.forEach((data, i) => {
        if (i === 0) {
          this.programs.pdfUrl = `${this.baseURL}/storage/app/pdf/program/${data.pdf}`
          this.programs.imageUrl = `${this.baseURL}/storage/app/img/program/${data.image}`
        }
      })
    }
  },

  created () {
    this.$store.dispatch('symposium/checkDateAvailable')

    if (!this.programsRaw) {
      this.$store.dispatch('creativity/getProgram')
    } else {
      this.matchImgUrl(this.programsRaw)
    }
  },

  watch: {
    programsRaw (data) {
      this.matchImgUrl(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables.scss";

.wrap-program {
  padding: 22px 0;

  .box-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {

      color: #212529;

      /* h3-subtitle */
      font-family: var(--h3-font-family, "DB HelvethaicaMon X");
      font-size: var(--h3-font-size, 48px);
      font-style: normal;
      font-weight: var(--h3-font-weight, 500);
      line-height: normal;

      @media only screen and (min-width: $break-m) {
        font-size: 1.75rem;
      }
    }

    a {
      padding: 8px 28px;
      background-color: $active;
      text-align: center;
      color: #FFF;
      font-family: var(--button-default-font-family, "DB Adman X");
      font-size: var(--button-default-font-size, 20px);
      font-style: normal;
      font-weight: var(--button-default-font-weight, 400);
      line-height: normal;
    }

    .box-button-p10 a {
      margin: 0 10px;
    }
  }

  .box-content {
    margin-top: 22px;

    img {
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    .box-button-p10 {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
}
</style>
